const messages = {
  en: {
    title: 'Contact Us',
    help: 'We want to help!',
    more: 'Want to find out more?',
    reachout: 'Reach out via one of the methods below',
    reveal: 'Click to Reveal',
    close: 'Close',
    copy: 'Copy to clipboard',
    copyinstruction: 'Copy to clipboard: Ctrl+C or ⌘+C, Enter',
    sales: 'Looking for sales support?',
    footprint1:
      'Providing your contact information allows our representatives to provide you with personalized support',
    footprint2:
      "Please complete the optional fields below and click the 'Submit / Show Contact' button",
    footprintDisclaim:
      'Information will remain confidential and will not be used for advertising purposes',
    footprintReveal:
      'This is your unique customer reference ID. A support representative may ask you to provide this ID at the beginning of a call. Please contact us by calling the number below.',
    phoneInvalid: 'Phone must be valid or blank',
    emailInvalid: 'Email must be valid or blank'
  },
  'es-ud': {
    title: 'Contáctenos',
    help: '¡Queremos ayudarle!',
    more: '¿Quiere saber más?',
    reachout: 'Contáctenos mediante uno de los métodos siguientes',
    reveal: 'Haga Clic para Mostrar',
    close: 'Cerrar',
    copy: 'Copiar al portapapeles',
    copyinstruction: 'Copiar al portapapeles: Ctrl+C o ⌘+C, Enter',
    sales: '¿Busca asistencia en ventas?',
    footprint1:
      'Providing your contact information allows our representatives to provide you with personalized support',
    footprint2:
      "Please complete the optional fields below and click the 'Submit / Show Contact' button",
    footprintDisclaim:
      'Information will remain confidential and will not be used for advertising purposes',
    footprintReveal:
      'This is your unique customer reference ID. A support representative may ask you to provide this ID at the beginning of a call. Please contact us by calling the number below.',
    phoneInvalid: 'Phone must be valid or blank',
    emailInvalid: 'Email must be valid or blank'
  },
  es: {
    title: 'Contáctanos',
    help: '¡Queremos ayudarte!',
    more: '¿Quieres saber más?',
    reachout: 'Contáctanos mediante uno de los métodos siguientes',
    reveal: 'Haz Clic para Mostrar',
    close: 'Cerrar',
    copy: 'Copiar al portapapeles',
    copyinstruction: 'Copiar al portapapeles: Ctrl+C o ⌘+C, Enter',
    sales: '¿Buscas asistencia en ventas?',
    footprint1:
      'Providing your contact information allows our representatives to provide you with personalized support',
    footprint2:
      "Please complete the optional fields below and click the 'Submit / Show Contact' button",
    footprintDisclaim:
      'Information will remain confidential and will not be used for advertising purposes',
    footprintReveal:
      'This is your unique customer reference ID. A support representative may ask you to provide this ID at the beginning of a call. Please contact us by calling the number below.',
    phoneInvalid: 'Phone must be valid or blank',
    emailInvalid: 'Email must be valid or blank'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/components/ContactUsModal/messages.js